"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Deferred = void 0;
var Deferred = /** @class */ (function () {
    // update 062115 for typeof
    function Deferred() {
        var _this = this;
        /* A method to resolve the associated Promise with the value passed.
             * If the promise is already settled it does nothing.
             *
             * @param {anything} value : This value is used to resolve the promise
             * If the value is a Promise then the associated promise assumes the state
             * of Promise passed as value.
             */
        this.resolve = function () { };
        /* A method to reject the assocaited Promise with the value passed.
             * If the promise is already settled it does nothing.
             *
             * @param {anything} reason: The reason for the rejection of the Promise.
             * Generally its an Error object. If however a Promise is passed, then the Promise
             * itself will be the reason for rejection no matter the state of the Promise.
             */
        this.reject = function () { };
        this.promise = new Promise(function (resolve, reject) {
            _this.resolve = resolve;
            _this.reject = reject;
        });
        Object.freeze(this);
    }
    return Deferred;
}());
exports.Deferred = Deferred;
